/**
 * Class names, merged so the last Tailwind utility of a kind wins.
 *
 * Plain `clsx` alone concatenates, so a component's own `px-4` and a caller's
 * `px-6` both end up in the class list and the winner is whichever Tailwind
 * happened to emit later in the stylesheet — which changes between builds.
 * `twMerge` resolves it by utility group, deterministically.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
